import { FC } from 'react';

import { useEscAction } from 'hooks/useEscAction';

import { IEscKeyHandlerProps } from './types';

const EscKeyHandler: FC<IEscKeyHandlerProps> = ({ children, onEscapeClick = () => {} }) => {
  useEscAction(() => onEscapeClick());

  return <>{children}</>;
};

export default EscKeyHandler;
